import { call, put, select } from 'redux-saga/effects';
import { pageContext } from 'ctm-util-functions';
import { prefillPayloadSelector } from 'ctm-selectors/selectors/user';
import { processRequestAndActionsSaga, processSagaWithRetries } from './utils';
import { getJourneyPayload, getMarketingRequestPayload } from './state_selectors';

/**
 * Start the Journey
 * @param {Object} action        - The action that describes the request.
 */
export const processNewJourneyAction = function* (action) {
    // don't re-fetch the journey payload if we already have it
    const journeyPayload = yield select(getJourneyPayload);

    if (journeyPayload.transaction) {
        yield put({ type: `${action.type}_SUCCESS` });
        return;
    }

    // Anonymous prefill calls
    // Set prefill object
    const { store } = pageContext.getProps();
    const pagePath = pageContext.getProps().pageState.path;
    store.dispatch({
        type: 'SET_VALUE',
        value: pagePath,
        stateKey: 'vertical.quote',
        identifier: 'helpers.prefill.lastViewedPage'
    });
    // This will always be false as this function is only called on new journey start
    store.dispatch({
        type: 'SET_VALUE',
        value: false,
        stateKey: 'vertical.quote',
        identifier: 'helpers.prefill.eligiblePage'
    });
    store.dispatch({
        type: 'SET_VALUE',
        value: 0,
        stateKey: 'vertical.quote',
        identifier: 'helpers.prefill.attempt'
    });
    const prefill = prefillPayloadSelector(store.getState());

    // set the request Payload
    // @todo: when BE implemented journey/load for energy, we can then get rid of this and make a separate call to save
    // marketing data through journey/<journeyId>/marketings
    const requestPayload = yield select(getMarketingRequestPayload);
    const pageName = pageContext.getProps().pageState.pageName;
    if  (pageContext.getVertical() === 'car-insurance') {
        // do not create a journey on the car postcode verification page
        if (['quotes_expired', 'verify'].includes(pageName)) {
            return;
        }

        const newJourneyPayload = {
            marketing: requestPayload,
            clientMetadata: getClientMetadataPayload(),
            prefill
        };
        yield call(processSagaWithRetries, processRequestAndActionsSaga, action, newJourneyPayload);
    } else if (requestPayload?.experimentId && pageContext.getVertical() === 'home-contents-insurance') {
        // HNC passing experiment value
        const newJourneyPayload = {
            journeyMarketings: [{
                experimentId: requestPayload.experimentId
            }],
            clientMetadata: getClientMetadataPayload(),
            prefill
        };
        yield call(processSagaWithRetries, processRequestAndActionsSaga, action, newJourneyPayload);
    } else {
        // https://dev.azure.com/ctmaus/CTM/_workitems/edit/22176
        // Added this if-else case because RPO requires a certain marketing payload which HNC/Energy does not use.

        const newJourneyPayloadHNC = {
            ...requestPayload,
            clientMetadata: getClientMetadataPayloadHNC(),
            prefill
        };
        yield call(processSagaWithRetries, processRequestAndActionsSaga, action, newJourneyPayloadHNC);
    }
};

// This will need to be standardised in future.
const getClientMetadataPayloadHNC = () => {
    return {
        client: {
            anonymousId: sessionStorage.getItem('user_anonymous_id') ?? '',
            userId: sessionStorage.getItem('user_id') ?? ''
        }
    };
};

const getClientMetadataPayload = () => {
    const deviceCategory = sessionStorage.getItem('deviceCategory');
    return {
        client: {
            clientDeviceCategory: deviceCategory !== null ? deviceCategory.toUpperCase() : 'DESKTOP', // this needs to be all uppercase
            clientDeviceOS: navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
            clientDeviceOSVersion: '',
            clientBrowser: navigator.userAgentData ? navigator.userAgentData.brands[0].brand : '',
            clientBrowserVersion: navigator.userAgentData ? navigator.userAgentData.brands[0].version : '',
            anonymousId: sessionStorage.getItem('user_anonymous_id') ?? '',
            userId: sessionStorage.getItem('user_id') ?? ''
        },
        clientSessionScope: {
            sessionId: window.sessionStorage.getItem('sessionID'),
            referrer: window.sessionStorage.getItem('referrer'),
            utm_medium: window.sessionStorage.getItem('utm_medium'),
            utm_source: window.sessionStorage.getItem('utm_source'),
            utm_campaign: window.sessionStorage.getItem('utm_campaign'),
            utm_content: window.sessionStorage.getItem('utm_content'),
            utm_term: window.sessionStorage.getItem('utm_term'),
            clickID_type: window.sessionStorage.getItem('clickID_TYPE'),
            clickID_value: window.sessionStorage.getItem('clickID_VALUE'),
            mktCloud_subscriberId: '',
            reportingChannel: window.sessionStorage.getItem('reportingChannel')
        }
    };
};
